// /app/frontend/src/components/chat/assistNudge.js

const DAY_MS = 24 * 60 * 60 * 1000;
const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

function safeNum(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

export function getNudgeKeys({ userId, matchId }) {
  const base = `assist_nudge:${userId || "anon"}:${matchId || "nomatch"}`;
  return {
    lastShown: `${base}:lastShown`,
    lastDismissed: `${base}:lastDismissed`,
    lastUsed: `${base}:lastUsed`,
    lastMsgCount: `${base}:lastMsgCount`,
    lastEligibleReason: `${base}:lastEligibleReason`,
  };
}

export function isEligibleForNudge({ messages, userId, matchId }) {
  if (!matchId || !userId) return { eligible: false, reason: null };
  if (!Array.isArray(messages) || messages.length < 6) return { eligible: false, reason: null };

  const keys = getNudgeKeys({ userId, matchId });
  const now = Date.now();

  const lastShown = safeNum(localStorage.getItem(keys.lastShown));
  const lastDismissed = safeNum(localStorage.getItem(keys.lastDismissed));
  const lastUsed = safeNum(localStorage.getItem(keys.lastUsed));

  // Hard cooldown: once per 24h if shown/dismissed/used
  if (now - lastShown < DAY_MS) return { eligible: false, reason: null };
  if (now - lastDismissed < DAY_MS) return { eligible: false, reason: null };
  if (now - lastUsed < DAY_MS) return { eligible: false, reason: null };

  // Condition A: 12h since last message
  const lastMsg = messages[messages.length - 1];
  const lastTs = new Date(
    lastMsg?.timestamp || lastMsg?.created_at || lastMsg?.time || 0
  ).getTime();
  const inactivityOk = lastTs && now - lastTs >= TWELVE_HOURS_MS;

  // Condition B: 10+ messages since last time we recorded a checkpoint
  const lastCount = safeNum(localStorage.getItem(keys.lastMsgCount));
  const delta = messages.length - lastCount;
  const countOk = delta >= 10;

  if (inactivityOk) return { eligible: true, reason: "inactivity_12h" };
  if (countOk) return { eligible: true, reason: "messages_10" };
  return { eligible: false, reason: null };
}

export function markNudgeShown({ userId, matchId, messagesLength, reason }) {
  const keys = getNudgeKeys({ userId, matchId });
  const now = Date.now();
  localStorage.setItem(keys.lastShown, String(now));
  localStorage.setItem(keys.lastMsgCount, String(messagesLength || 0));
  if (reason) localStorage.setItem(keys.lastEligibleReason, reason);
}

export function markNudgeDismissed({ userId, matchId, messagesLength }) {
  const keys = getNudgeKeys({ userId, matchId });
  const now = Date.now();
  localStorage.setItem(keys.lastDismissed, String(now));
  localStorage.setItem(keys.lastMsgCount, String(messagesLength || 0));
}

export function markNudgeUsed({ userId, matchId, messagesLength }) {
  const keys = getNudgeKeys({ userId, matchId });
  const now = Date.now();
  localStorage.setItem(keys.lastUsed, String(now));
  localStorage.setItem(keys.lastMsgCount, String(messagesLength || 0));
}
